import {Route, Routes} from "react-router-dom";
import {lazy, Suspense} from "react";
import AboutUsPage from "../app/components/misc/about-us";
import Thanks from "../app/components/misc/thanks";
import PrivacyPage from "../app/components/misc/privacy";

// import Home1Page from "../app/components/home/index";
// import Home2Page from "../app/components/home/index2";
// import Home3Page from "../app/components/home/index3";
// import Home4Page from "../app/components/home/index4";
// import AboutUsPage from "../app/components/misc/about-us";
// import ContactPage from "../app/components/misc/contact-us";
// import FaqPage from "../app/components/misc/faq";
// import Error404Page from "../app/components/misc/error404";
// import BlogGridPage from "../app/components/blogs/blog-grid";
// import BlogsDetailPage from "../app/components/blogs/blog-detail";
// import Services1Page from "../app/components/services/services1";
// import Services2Page from "../app/components/services/services2";
// import ServicesDetailPage from "../app/components/services/services-detail";

const Home1Page = lazy(() => import("../app/components/home/index"));
const Error404Page = lazy(() => import("../app/components/misc/error404"));
const TermsAndConditionsPage = lazy(() => import("../app/components/misc/terms-and-conditions"));
const BlogsDetailPage = lazy(() => import("../app/components/blogs/blog-detail"));

// Google Ads landing oldalak - sajat URL, sajat szoveg, sajat SEO
const KoltoztetesBudapestPage = lazy(() => import("../app/components/landing/koltoztetes-budapest"));
const LomtalanitasBudapestPage = lazy(() => import("../app/components/landing/lomtalanitas-budapest"));

function AppRoutes() {
    return (
        <Suspense fallback={<div>Betöltés...</div>}>
            <Routes>
                <Route path='/' element={<Home1Page/>}/>
                {/*<Route path='/index' element={<Home1Page />} />*/}
                {/*<Route path='/index2' element={<Home2Page />} />*/}
                {/*<Route path='/index3' element={<Home3Page />} />*/}
                {/*<Route path='/index4' element={<Home4Page />} />*/}
                <Route path='/koszonjuk' element={<Thanks />} />
                <Route path='/koltoztetes-budapest' element={<KoltoztetesBudapestPage/>}/>
                <Route path='/lomtalanitas-budapest' element={<LomtalanitasBudapestPage/>}/>
                {/*<Route path='/faq' element={<FaqPage />} />*/}
                {/*<Route path='/error404' element={<Error404Page />} />*/}
                {/*<Route path='/services/services1' element={<Services1Page />} />*/}
                {/*<Route path='/services/services2' element={<Services2Page />} />*/}
                {/*<Route path='/services/detail' element={<ServicesDetailPage />} />*/}
                <Route path='/blogs/:id' element={<BlogsDetailPage/>}/>
                <Route path='/aszf' element={<TermsAndConditionsPage />}/>
                <Route path='/adatvedelem' element={<PrivacyPage />}/>
                {/*<Route path='/contact-us' element={<ContactPage />} />*/}
                <Route path='*' element={<Error404Page/>}/>
            </Routes>
        </Suspense>
    )
}

export default AppRoutes;